import React from 'react'
import { Field } from 'redux-form'
import FormControl from '@material-ui/core/FormControl'
import InputLabel from '@material-ui/core/InputLabel'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import FilledInput from '@material-ui/core/FilledInput'
import { withStyles, makeStyles } from '@material-ui/core/styles'

const useLabelStyles = makeStyles({
	inputRoot: {
		color: 'black',
	},
	inputFocused: {
		color: 'black',
	},
	inputLabel: {
		marginLeft: '0px',
		color: 'black',
	},
	selectMenu: {
		color: 'black',
		height: '1.26em'
	},
	selectIcon: {
		fontSize: '24px',
	},
})

const renderSelectField = ({ 
	input, 
	label, 
	meta: { touched, error, submitFailed }, 
	children, 
	name, 
	labelStyles,
	errorCallback,
	...custom }) => {
	return (
		<FormControl error={touched && error} errorCallback={errorCallback && errorCallback(submitFailed && error)} fullWidth>
			<InputLabel
				data-testid='filled-input-select'
				htmlFor={name}
				classes={{
					root: labelStyles.root,
					focused: labelStyles.focused
				}}
			>
				{label}
			</InputLabel>
			<Select
				data-testid='filled-formcontrol-select'
				fullWidth
				{...input}
				{...custom}
				inputProps={{
					name: name,
					id: name
				}}
				classes={{ icon: labelStyles.icon }}
				input={<FilledInput id={name} name={name} />}
			>
				{children}
			</Select>
		</FormControl>
	)
}

const FilledInputSelect = ({ label, name, onChange, data, classes, errorCallback, ...other }) => {
	var labelStyles = useLabelStyles()
	return (
		<Field
			data-testid='filled-input-field'
			component={renderSelectField}
			name={name}
			onChange={onChange}
			label={label}
			labelStyles={labelStyles}
			errorCallback={errorCallback}
			{...other}
		>
			{data &&
				data.map((r) => (
					<MenuItem data-testid='filled-input-field-menuitem' key={r.value} value={r.value}>
						{r.name}
					</MenuItem>
				))}
		</Field>
	)
}

export default FilledInputSelect
